import { cva, type VariantProps } from 'class-variance-authority'

export { default as Input } from './Input.vue'

export const inputVariants = cva(
  'flex w-full rounded-6xl px-3 border-none bg-neutral-light-default text-s-medium shadow-none transition-colors text-text-active placeholder:text-text-explanatory-default hover:ring-n-light-hover hover:ring-1 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-theme-light-active disabled:cursor-not-allowed disabled:bg-neutral-dark-disabled disabled:hover:ring-0',
  {
    variants: {
      size: {
        lg: 'py-3.5',
        md: 'py-2.5',
        sm: 'py-1.5',
      },
    },
    defaultVariants: {
      size: 'md',
    },
  },
)

export type InputVariants = VariantProps<typeof inputVariants>
